import {Alert, Button, Col, Row, Space, Typography} from "antd";
import React from "react";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {authStore} from "../data";
import {IUserImportError} from "../types";

interface IProps {
  error: IUserImportError;
}

const UserImportError: React.FC<IProps> = ({error}) => {
  const dispatch = useDispatch();
  const {actions} = authStore;
  const clearError = () => {
    dispatch(actions.setError(undefined));
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        alignItems: "center"
      }}
    >
      <Alert
        style={{width: 360}}
        message={<b>Произошла ошибка при синхронизации учетной записи</b>}
        description={
          <>
            <p>{error.message}</p>
            <p style={{margin: 0}}>
              Для смены пароля перейдите{" "}
              <a target="_blank" rel="noreferrer" href={error.changePasswordLink}>
                по ссылке
              </a>
            </p>
          </>
        }
        type="error"
      />
      <Button onClick={clearError} style={{width: 220, marginTop: 10}}>
        Назад
      </Button>
    </div>
  );
};

export default UserImportError;
